import { useEffect } from 'react';
import { useContactsStore } from '@lib/store';

export const Contacts = () => {
  const contactsStore = useContactsStore();

  useEffect(() => {
    contactsStore.getContacts();
  }, []);

  return (
    <div className='text-center text-lg text-white uppercase'>
      <div className='mt-1 text-white normal-case'>
        <span className='mr-1 text-[#c4c4c4]'>Address:</span>{' '}
        {`${contactsStore.data?.Address ? contactsStore.data?.Address : '18 Soho Square W1D 3QL, London, UK'}`}
      </div>
      {contactsStore.data?.Phone1 && (
        <div className='mt-1 text-white normal-case'>
          <span className='mr-1 text-[#c4c4c4]'>International line:</span> {`${contactsStore.data?.Phone1}`}
        </div>
      )}
      {contactsStore.data?.Phone2 && (
        <div className='mt-1 text-white normal-case'>
          <span className='mr-1 text-[#c4c4c4]'>Uk toll free line:</span> {`${contactsStore.data?.Phone2}`}
        </div>
      )}
      <div className='mt-1 text-white normal-case'>
        <span className='mr-1 text-[#c4c4c4]'>Email us: </span> <a href={`mailto:${contactsStore.data?.Email}`}>{contactsStore.data?.Email}</a>
      </div>
    </div>
  );
};
